import { gql } from '@apollo/client';
import client from '../../../core/services/graphql';

export const PROJECTS = gql`
  query Projects($offset: Int!, $order: String!, $limit: Int!, $statusList: [ProjectStatusEnum!], $tableFilter: String ) {
    projectsCount(statusList: $statusList, tableFilter: $tableFilter)
    projects(offset: $offset, order: $order, limit: $limit, statusList: $statusList, tableFilter: $tableFilter) {
      id
      name
      testType
      createdAt
      completedAt
      qualifiedTestersNumber
      disqualifiedTestersNumber
      testersTakingStudy
      processedTestersNumber
      processingTestersNumber
      completedTestersNumber
      playbookTestersNumber
      testersNumberWithScreener
      status
      receivedTests
      participantsSource
      audienceParticipants
      shareCode
      company {
        id
        name
      }
      createdBy {
        id
        email
        profile {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const getProjects = async (params) => {
  const { data } = await client.getClient().query({
    query: PROJECTS,
    variables: {
      offset: params.offset,
      order: params.order,
      limit: params.limit,
      tableFilter: params.tableFilter,
      status: ['in_progress', 'done'],
    },
    fetchPolicy: 'no-cache',
  });

  return data;
};

export const GET_TEST_SESSIONS = gql`
  query TestSessionsApprovalsTab(
    $status: TestSessionStatusEnum,
    $projectId: ID!,
    $limit: Int,
  ) {
    testSessionsApprovalsTab(
      status: $status,
      projectId: $projectId,
      limit: $limit,
    ) {
      id
      approved
      removed
      tester {
        id
        screenerSession {
          id
        }
        segment {
          name
          createdAt
        }
        user {
          id
          tester
          profile {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const getTestSessions = async (params) => {
  const { data } = await client.getClient().query({
    query: GET_TEST_SESSIONS,
    variables: {
      limit: params.limit,
      projectId: params.projectId,
      status: 'processed',
    },
    fetchPolicy: 'no-cache',
  });

  return data;
};
